<template>
    <main>
		<section id="form">
            <div id="form-photo" class="align-items-center justify-content-center">

			</div>
			<div id="form-content">
                <div class="container mb-5">
                    <Logo outerClass="py-4 py-sm-5" color="_dark" innerClass="logo" type="png" />
                    <div style="max-width: 770px;">
                        <h3 class="uc">Welcome Back {{fname}}</h3>
                        <p class="light mb-4">Enter your details below and we'll pull up your previous data for quick resubmission.</p>
                        <LoginLeadForm :show="true" />
                    </div>
                </div>

                <Footer />

			</div>
			
		</section>
	</main>

</template>

<script>
// @ is an alias to /src
import LoginLeadForm from '@/components/home/LoginLeadForm.vue';
import Logo from '@/components/Logo.vue';
import Footer from '@/components/Footer.vue';

import { mapGetters, mapActions } from "vuex";

export default {
  name: 'Login',
  title: 'Login',
  components: {
	LoginLeadForm,
	Logo,
	Footer
  },
  data(){
      return {
          fname: ''
      }
  },
  methods: {
	...mapActions(["toggleLeadForm"]),
  },
  computed: mapGetters(["allSettings"]),
  created(){
    const urlParams = new URLSearchParams(window.location.search);
    this.fname = urlParams.has('fname') ? urlParams.get('fname') : '';
  }
}
</script>

